// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css - Minimal overrides for Tailwind-based components */

/* Ensure proper prose styling for markdown content */
.prose {
  max-width: none;
}

.prose p {
  margin-bottom: 0.75rem;
}

.prose p:last-child {
  margin-bottom: 0;
}

.prose ul, .prose ol {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
}

.prose li {
  margin: 0.25rem 0;
}

.prose code {
  background-color: hsl(var(--muted));
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  font-size: 0.875em;
}

.prose pre {
  background-color: hsl(var(--muted));
  padding: 1rem;
  border-radius: 0.5rem;
  overflow-x: auto;
  margin: 0.75rem 0;
}

.prose pre code {
  background-color: transparent;
  padding: 0;
}

.prose table {
  width: 100%;
  border-collapse: collapse;
  margin: 0.75rem 0;
}

.prose th, .prose td {
  border: 1px solid hsl(var(--border));
  padding: 0.5rem 0.75rem;
  text-align: left;
}

.prose th {
  background-color: hsl(var(--muted));
  font-weight: 600;
}

.prose strong {
  font-weight: 600;
}

.prose h1, .prose h2, .prose h3, .prose h4 {
  font-weight: 600;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.prose h1 { font-size: 1.5rem; }
.prose h2 { font-size: 1.25rem; }
.prose h3 { font-size: 1.125rem; }
.prose h4 { font-size: 1rem; }

/* Dark mode prose adjustments */
.dark .prose {
  color: hsl(var(--foreground));
}

.dark .prose code {
  background-color: hsl(var(--muted));
}

.dark .prose pre {
  background-color: hsl(var(--muted));
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D,qDAAqD;AACrD;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,YAAY,iBAAiB,EAAE;AAC/B,YAAY,kBAAkB,EAAE;AAChC,YAAY,mBAAmB,EAAE;AACjC,YAAY,eAAe,EAAE;;AAE7B,gCAAgC;AAChC;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["/* App.css - Minimal overrides for Tailwind-based components */\n\n/* Ensure proper prose styling for markdown content */\n.prose {\n  max-width: none;\n}\n\n.prose p {\n  margin-bottom: 0.75rem;\n}\n\n.prose p:last-child {\n  margin-bottom: 0;\n}\n\n.prose ul, .prose ol {\n  margin: 0.5rem 0;\n  padding-left: 1.5rem;\n}\n\n.prose li {\n  margin: 0.25rem 0;\n}\n\n.prose code {\n  background-color: hsl(var(--muted));\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n  font-size: 0.875em;\n}\n\n.prose pre {\n  background-color: hsl(var(--muted));\n  padding: 1rem;\n  border-radius: 0.5rem;\n  overflow-x: auto;\n  margin: 0.75rem 0;\n}\n\n.prose pre code {\n  background-color: transparent;\n  padding: 0;\n}\n\n.prose table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0.75rem 0;\n}\n\n.prose th, .prose td {\n  border: 1px solid hsl(var(--border));\n  padding: 0.5rem 0.75rem;\n  text-align: left;\n}\n\n.prose th {\n  background-color: hsl(var(--muted));\n  font-weight: 600;\n}\n\n.prose strong {\n  font-weight: 600;\n}\n\n.prose h1, .prose h2, .prose h3, .prose h4 {\n  font-weight: 600;\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.prose h1 { font-size: 1.5rem; }\n.prose h2 { font-size: 1.25rem; }\n.prose h3 { font-size: 1.125rem; }\n.prose h4 { font-size: 1rem; }\n\n/* Dark mode prose adjustments */\n.dark .prose {\n  color: hsl(var(--foreground));\n}\n\n.dark .prose code {\n  background-color: hsl(var(--muted));\n}\n\n.dark .prose pre {\n  background-color: hsl(var(--muted));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
